$.widget('sensibio.accordion', {
	options: {
		selectors: {
			trigger: '[data-role=trigger]',
			content: '[data-role=content]',
			item: '[data-role=item]'
		},
		classes: {
			active: '_active',
		},
	},

	_create() {
		this._bind();
	},

	_bind() {
		this._cache();
		this._events();
	},

	_cache() {
		const { selectors } = this.options;

		this.$element = $(this.element);
		this.$trigger = this.$element.find(selectors.trigger);
		this.$item = this.$element.find(selectors.item);
	},

	_events() {
		this._on(this.$item, {
			click: this.onItemClick,
		});
	},

	onItemClick(event) {
		const { selectors, classes } = this.options;

		const $currentItem = $(event.currentTarget);
		const isActive = $currentItem.hasClass(classes.active);

		this.$item.removeClass(classes.active);
		// Убираем inline-height/padding, которые могли проставиться
		// предыдущими slideUp/slideDown и мешают CSS-переходам.
		this.$item
			.find(selectors.content)
			.stop(true, true)
			.removeAttr('style');

		if (!isActive) {
			$currentItem.addClass(classes.active);
		}
	}
});